import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSunMoonGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M35.927 37.257c2.845-2.123 3.399-6.193 1.448-8.75a6.506 6.506 0 0 0-1.77-1.62c1.178 1.986 1.303 4.095.34 6.27a.75.75 0 0 1-1.371-.606c1.05-2.376.493-4.574-1.76-6.744-.532-.513-.08-1.405.648-1.28 2.113.366 3.826 1.395 5.105 3.07 2.456 3.218 1.773 8.239-1.743 10.862-3.166 2.361-8.125 1.833-10.822-2.051-.442-.638.257-1.446.951-1.1 2.47 1.233 4.935.597 6.54-1.236a.75.75 0 1 1 1.129.988c-1.394 1.592-3.332 2.48-5.417 2.38 2.157 1.334 4.849 1.214 6.722-.183ZM18.5 22.75a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Zm0-1.5a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5Zm-10-2a.75.75 0 0 1 0-1.5h4a.75.75 0 1 1 0 1.5h-4Zm16 0a.75.75 0 0 1 0-1.5h4a.75.75 0 1 1 0 1.5h-4ZM11.96 26.1a.75.75 0 0 1-1.062-1.06l2.829-2.829a.75.75 0 1 1 1.06 1.06l-2.828 2.83Zm11.313-11.313a.75.75 0 0 1-1.06-1.061l2.828-2.829a.75.75 0 1 1 1.06 1.061l-2.828 2.829ZM26.1 25.04a.75.75 0 0 1-1.06 1.06l-2.829-2.828a.75.75 0 0 1 1.06-1.06l2.83 2.828ZM14.788 13.727a.75.75 0 0 1-1.061 1.06l-2.829-2.828a.75.75 0 1 1 1.061-1.06l2.829 2.828ZM19.25 28.5a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 1.5 0v4Zm0-16a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 1.5 0v4Z",
    fill: "currentColor"
  }));
}

export { SvgSunMoonGlyphSecondary as default };
